import { Form, Row, Col, Button, Select } from 'antd';
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useFieldArray, } from "react-hook-form";
import { Trash, Plus, } from "@phosphor-icons/react";

const CustomerUserGroupsFormView = ({
    history,
    control,
    userGroups,
    title = "customer-user-groups-info",
    formDisabled = false,
    ...props
}) => {

    const intl = useIntl();
    const user_group_ids = useFieldArray({
        control,
        name: "user_group_ids"
    });

    return (
        <Form>
            <p><FormattedMessage id={title || 'not-set'} /></p>
            <div className="mt-4">

                {/* Create header */}
                <Row gutter={24}>
                    {/* User group */}
                    <Col span={15} className="text-first-capital">
                        <strong><FormattedMessage id="user-group" /></strong>
                    </Col>

                    {/* <Col span={8} className="text-center">
                        <strong><Tooltip title={intl.formatMessage({ id: 'customer-default-group-tt' })}>
                            <Info size={16} weight="light" className="mx-1" /> <FormattedMessage id="default-group" />
                        </Tooltip></strong>
                    </Col> */}
                </Row>

                {/* Always the administrator group */}
                <Row gutter={24} align="middl" justify="space-around" className="py-2">
                    <Col span={15}>
                        Administrators (Built-In)
                    </Col>
                    <Col span={3} className="text-center">
                    </Col>
                    <Col span={6} className="">
                        <Button hidden={formDisabled} size="small" onClick={_ => user_group_ids.append()}><Plus size={16} /></Button>
                        <Button hidden={formDisabled} size="small" disabled={true} className="ml-1" danger={true}><Trash size={16} /></Button>
                    </Col>
                </Row>

                {/* Show user group fields */}
                {user_group_ids.fields.map((item, index) => (
                    <Row gutter={24} key={item.id}>
                        <Col span={15}>
                            <Controller
                                control={control}
                                name={`user_group_ids.${index}.ug_id`}
                                rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        help={error && intl.formatMessage({ id: error?.message })}
                                        hasFeedback
                                        validateStatus={error?.message && "error"}
                                        required
                                    >
                                        <Select
                                            disabled={formDisabled}
                                            options={userGroups}
                                            onChange={onChange}
                                            value={value}
                                            placeholder={<FormattedMessage id="make-choice" />}
                                        />
                                    </Form.Item>
                                )}
                            />
                        </Col>

                        <Col span={3} className="text-center">
                            {/* <Controller
                                control={control}
                                defaultValue={false}
                                name={`user_group_ids.${index}.default_group`}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item>
                                        <Switch
                                            onChange={onChange}
                                            checked={value}
                                        />
                                    </Form.Item>
                                )}
                            /> */}
                        </Col>

                        <Col span={6} style={{ paddingTop: 4 }}>
                            <Button hidden={formDisabled} size="small" onClick={e => user_group_ids.append()}><Plus size={16} /></Button>
                            <Button hidden={formDisabled} size="small" onClick={e => user_group_ids.remove(index)} className="ml-1" danger={true}><Trash size={16} /></Button>
                        </Col>

                    </Row>
                ))}
            </div>

        </Form>
    );
};

export default CustomerUserGroupsFormView;
